import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["condensed", "as", "variant", "semanticColor"];
import React from 'react';
import { Type } from "../Type";
export var EmptyStateText = function EmptyStateText(_ref) {
  var _ref$condensed = _ref.condensed,
      condensed = _ref$condensed === void 0 ? true : _ref$condensed,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'p' : _ref$as,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'body2' : _ref$variant,
      _ref$semanticColor = _ref.semanticColor,
      semanticColor = _ref$semanticColor === void 0 ? 'textBase' : _ref$semanticColor,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Type, Object.assign({
    as: as,
    variant: variant,
    semanticColor: semanticColor
  }, props));
};
/**
* **EmptyStateText** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/EmptyStateText) | [Storybook](https://encore-web.spotify.net/?path=/docs/components-emptystate-emptystatetext--default) |  
*
* EmptyStateText provides relevant info that's not already covered in EmptyStateTitle (headline).
*
* @example
* () => (
*  <EmptyStateText>No content found here. Please try again later.</EmptyStateText>
*);
*
*/

export default EmptyStateText;